var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table"},[_c('div',{staticClass:"table__header"},[_vm._t("header")],2),_vm._t("default"),_vm._m(0)],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table__caliente"},[_c('div',[_vm._v(" Haz click aquí para realizar esta apuesta en ")]),_c('div',[_c('img',{attrs:{"src":"https://az755631.vo.msecnd.net/golstats-bets/caliente_2020.svg","alt":""}})])])
}]

export { render, staticRenderFns }